module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_9.430c34e1.jpg";